import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Stepper, Step, StepLabel, Button, Typography, IconButton, Stack, Tabs, Tab, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types';
import CancelIcon from '@mui/icons-material/Cancel';
import { Checkbox, TextField } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import Webcam from 'react-webcam';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent, TimelineOppositeContent, timelineOppositeContentClasses } from '@mui/lab';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { timelineItemClasses } from '@mui/lab/TimelineItem';
import Dialog from '@mui/material/Dialog';
import IconTint from 'react-icon-tint';
import DialogTitle from '@mui/material/DialogTitle';
import { v4 as uuidv4 } from 'uuid';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import Check from '@mui/icons-material/Check';
import Switch from '@mui/material/Switch';
import StepContent from '@mui/material/StepContent';
import cameraicon from '../Assets/images/camera - Copy.png'
import micicon from '../Assets/images/Mike - Copy.png'
import WellnessStore from '../DataRepo/WellnessStore';
import { profileModel } from '../Axios/AxiosConfig';
import { getUserDetails } from '../Auth/AuthUtil';
import { useNavigate } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import loadingimg from '../Assets/images/loading image 1.png'
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '../Assets/images/Edit Icon.png'
import { CircularProgress, InputAdornment } from '@mui/material';
import VoiceInput from './VoiceInput';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Brightness5Icon from '@mui/icons-material/Brightness5';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import middayIcon from '../Assets/images/midday_icon.png'
import MorningIcon from '../Assets/images/Morning.png'
import AfternoonIcon from '../Assets/images/Afternoon.png'
import EveningIcon from '../Assets/images/Evening.png'
import NightIcon from '../Assets/images/Night.png'
import MorningActiveIcon from '../Assets/images/Morning grey.png'
import AfternoonActiveIcon from '../Assets/images/Afternoon grey.png'
import EveningActiveIcon from '../Assets/images/Evening grey.png'
import NightActiveIcon from '../Assets/images/Night grey.png'

const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '30%',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.grey[700],
    }),
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                backgroundColor:
                    '#8CEB8C',
                boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            },
        },
        {
            props: ({ ownerState }) => ownerState.completed,
            style: {
                backgroundColor:
                    '#8CEB8C',
            },
        },
    ],
}));

function ColorlibStepIcon(props) {
    const { active, completed, className } = props;

    const icons = {
        1: <Check />,
        2: <Check />,
        3: <Check />,
        4: <Check />
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


const ActivityTimeline = () => {

    const [activeStep, setActiveStep] = useState(0);

    const [selectedTab, setSelectedTab] = useState(null);

    const timer = React.useRef(undefined);

    const { getWeeklyRecommendation, isWeeklyRecommendationLoading, updateActivitylineItem, WeeklyRecommendation } = WellnessStore()

    const [currentLineItem, setCurrentLineItem] = useState(null)

    const [shouldUpdateLineItem, setShouldUpdateLineItem] = useState(false);

    const [recipeAnalysis, setRecipeAnalysis] = useState(null)

    const [recipeAnalysisloading, setRecipeAnalysisLoading] = useState(false)

    const [newRecipe, setNewRecipe] = useState('')

    const navigate = useNavigate()

    const [success, setSuccess] = useState(false);

    const [allReports, setReports] = useState([]);

    const [key, setKey] = useState(0);

    const scrollContainerRef = useRef(null);

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const getMealLabel = (timing) => {
        switch (timing) {
            case "morning": return "Breakfast";
            case "midday": return "Mid-day-snack";
            case "afternoon": return "Lunch";
            case "evening": return "Snacks";
            case "night": return "Dinner";
            default: return "Meal";
        }
    };


    const videoConstraints = {
        width: 500,
        height: 350,
        facingMode: 'environment',
    };

    const buttonSx = {
        bgcolor: '#8CEB8C',
        '&:hover': {
            bgcolor: '#8CEB8C',
        },
    };

    const cardRefs = useRef([]);

    cardRefs.current = WeeklyRecommendation?.map((_, i) => cardRefs?.current[i] ?? React?.createRef());

    const webcamRef = useRef(null);

    function cleanJsonString(rawString) {
        return rawString
            .replace(/```json/, '')
            .replace(/```$/, '')
            .trim();
    }

    const uploadRecipeImage = async (file, filename) => {
        try {

            setRecipeAnalysisLoading(true)

            const res = await profileModel.post('/UpdateRecipepictureTest', {
                UID: getUserDetails()?.UID,
                data: file,
                filename,
            })

            if (res.status === 200) {

                const { data, analysis } = res?.data
                const raw = analysis;
                const cleanedJson = raw ? cleanJsonString(raw) : null;
                const parsedData = cleanedJson ? JSON.parse(cleanedJson) : null;

                setRecipeAnalysis({
                    ...parsedData,
                    data
                })

                setNewRecipe(parsedData?.title || '')

                webcamRef.current = null;

            }
        }
        catch (err) {
            console.log(err)
        }
    }



    const capture = useCallback(() => {

        const imageSrc = webcamRef.current.getScreenshot().replace('data:', '').replace(/^.+,/, '');

        const fileId = uuidv4();

        const fileName = `CapturedImage_${fileId}.jpg`;

        setReports((prev) => [
            ...prev,
            {
                file: imageSrc,
                fileName
            },
        ]);

        uploadRecipeImage(imageSrc, fileName)

        setKey(prev => prev + 1);

        webcamRef.current = null;

        handleClose()

    }, [webcamRef, open2]);

    useEffect(() => {
        if (cardRefs?.current[selectedTab]) {
            cardRefs.current[selectedTab]?.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    }, [selectedTab]);

    useEffect(() => {
        if (cardRefs?.current[activeStep]) {
            cardRefs.current[activeStep]?.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    }, [activeStep]);


    const getCurrentSlot = () => {

        const indiaTime = new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });


        const hours = new Date(indiaTime).getHours();


        if (hours >= 6 && hours < 10) {
            setActiveStep(0);
        }

        else if (hours >= 10 && hours < 12) {
            setActiveStep(1);
        }

        else if (hours >= 12 && hours < 16) {
            setActiveStep(2);
        }

        else if (hours >= 16 && hours < 19) {
            setActiveStep(3);
        }

        else if (hours >= 19 || hours < 6) {
            setActiveStep(4);
        }

        else {
            setActiveStep(-1);
        }
    }

    useEffect(() => {

        const interval = setInterval(() => {
            getCurrentSlot();
        }, 1000);

        return () => clearInterval(interval);

    }, []);



    useEffect(() => {
        getWeeklyRecommendation()
    }, [open, open2])

    const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 22,
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor:
                    '#8CEB8C',
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor:
                    '#8CEB8C',
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 3,
            border: 0,
            backgroundColor: '#eaeaf0',
            borderRadius: 1,
            ...theme.applyStyles('dark', {
                backgroundColor: theme.palette.grey[800],
            }),
        },
    }));

    const updateLineItem = async () => {
        try {

            const res = await profileModel.put('/update-lineItem', {

                UID: getUserDetails()?.UID,
                timing: currentLineItem?.timing,
                type: currentLineItem?.type,
                lineItemIndex: currentLineItem?.lineItemIndex,
                updatedItems: currentLineItem?.item
            })

            if (res.status === 200) {
                setCurrentLineItem(null)
                handleClose()
                setRecipeAnalysis(null)
            }

        }

        catch (err) {
            console.log(err?.response?.data)
        }

    };

    useEffect(() => {
        if (shouldUpdateLineItem) {
            updateLineItem();
            setShouldUpdateLineItem(false);
        }
    }, [shouldUpdateLineItem]);

    const timeSlots = [
        { label: 'Morning', icon: MorningIcon, activeIcon: MorningActiveIcon },
        { label: 'Mid-day-snack', icon: middayIcon, activeIcon: middayIcon },
        { label: 'Afternoon', icon: AfternoonIcon, activeIcon: AfternoonActiveIcon },
        { label: 'Evening', icon: EveningIcon, activeIcon: EveningActiveIcon },
        { label: 'Night', icon: NightIcon, activeIcon: NightActiveIcon }
    ];

    const foodtimings = {
        morning: 'breakfast',
        midday: 'mid-day-snack',
        afternoon: 'lunch',
        evening: 'snacks',
        night: 'dinner',
    }

    const getIcon = (index) => {
        if (index < activeStep) {
            return <CheckCircleIcon style={{ color: 'orange' }} />;
        } else if (index === activeStep) {
            return React.cloneElement(timeSlots[index].icon, { style: { color: 'green' } });
        } else {
            return React.cloneElement(timeSlots[index].icon, { style: { color: 'gray' } });
        }
    };

    const getLabelColor = (index) => {
        if (index < activeStep) return 'orange';
        if (index === activeStep) return 'green';
        return 'gray';
    };

    const handleChange = (event, newValue) => {
        setActiveStep(newValue);
    };

    return <>
        {
            isWeeklyRecommendationLoading ?

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: '100vh' }}>
                    <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
                        <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
                        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
                        </div>
                    </div>
                </div> :

                WeeklyRecommendation.length > 0 &&

                <div className='mt-5' style={{ width: "100%" }}>

                    {/* <Stepper activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />}>
                        <Step>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>Morning (6 AM - 9 AM)</StepLabel>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>Morning (6 AM - 9 AM)</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>Afternoon (12 PM - 2 PM)</StepLabel>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>Afternoon (12 PM - 2 PM)</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>Evening (4 PM - 5 PM)</StepLabel>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>Evening (4 PM - 5 PM)</StepLabel>
                        </Step>
                        <Step>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>Night (7 PM - 9 PM)</StepLabel>
                            <StepLabel StepIconComponent={ColorlibStepIcon}>Night (7 PM - 9 PM)</StepLabel>
                        </Step>
                    </Stepper> */}

                    <Stack direction="row" spacing={2} justifyContent="space-between" mt={2} overflow={'scroll'} sx={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                        {timeSlots.map((slot, index) => {
                            const isCompleted = index < activeStep;
                            const isActive = index === selectedTab;
                            const isCurrentTime = index === activeStep;

                            let bgColor = '#efefe7';
                            let textColor = '#a5a39d';
                            let iconColor = undefined;

                            console.log(activeStep)

                            let iconSrc = slot.activeIcon || slot.icon;

                            if (isCompleted) {
                                bgColor = '#dbf9db';
                                textColor = '#3b362a';
                                iconColor = '#28a745';
                                iconSrc = slot.activeIcon || slot.icon;
                            }

                            if (isActive) {
                                bgColor = '#DA6E0B';
                                textColor = '#fdfdfd';
                                iconColor = '#ffffff';
                                iconSrc = slot.activeIcon || slot.icon;
                            }

                            if (isCurrentTime && !isActive) {
                                bgColor = '#8CEB8C';
                                textColor = '#3b362a';
                                iconColor = '#28a745';
                                iconSrc = slot.activeIcon || slot.icon;
                            }


                            return (
                                <Button
                                    key={slot.label}
                                    variant="outlined"
                                    onClick={() => !isCurrentTime && setSelectedTab(index)}
                                    startIcon={
                                        <IconTint src={iconSrc} color={iconColor || '#a5a39d'} style={{
                                            width: '24px',
                                            height: '24px',
                                            marginRight: '8px'
                                        }} />
                                    }
                                    sx={{
                                        backgroundColor: bgColor,
                                        color: textColor,
                                        fontWeight: isActive ? 'bold' : 'normal',
                                        px: 2,
                                        py: 1.5,
                                        width: '100%',
                                        borderRadius: 2,
                                        boxShadow: isCurrentTime ? '0 0 0 2px green inset' : 'none',
                                        border: 'none',
                                        '&:hover': {
                                            backgroundColor: bgColor,
                                            boxShadow: isCurrentTime ? '0 0 0 2px green inset' : 'none',
                                        }
                                    }}
                                >
                                    {slot.label}
                                </Button>
                            );
                        })}
                    </Stack>

                    <div
                        className="flex items-stretch justify-between mt-5 gap-5 weeklyrecommendationcards"
                        style={{ overflowX: "auto", flexWrap: "nowrap", flexShrink: 0 }}
                    >
                        {WeeklyRecommendation.map((e, i) => (
                            <div
                                key={i}
                                className="WeeklyRecommendationCard"
                                ref={cardRefs.current[i]}
                                style={{
                                    backgroundColor: activeStep === i ? "#FFEEDF" : "#F5F5F5",
                                    maxWidth: "100%",
                                    boxSizing: "border-box",
                                }}
                            >
                                <p>Suggested Time Line</p>

                                <Timeline
                                    sx={{
                                        [`& .${timelineItemClasses.root}:before`]: {
                                            flex: 0,
                                            padding: 0,
                                        },
                                    }}
                                >
                                    {e.lineItems.map((el, elI) => (
                                        <TimelineItem key={elI}>
                                            <TimelineSeparator>
                                                <TimelineDot
                                                    sx={{
                                                        backgroundColor: el.completed ? "#8CEB8C" : "grey",
                                                    }}
                                                />
                                                <TimelineConnector />
                                            </TimelineSeparator>
                                            <TimelineContent sx={{ maxWidth: "100%" }}>
                                                <div style={{ marginBottom: "20px" }}>
                                                    <p style={{ fontWeight: "400", fontSize: "16px" }}>
                                                        {el?.timing}
                                                    </p>

                                                    {/* Yoga */}
                                                    {el?.yoga && (
                                                        <div>
                                                            <div className="mt-3 flex justify-between items-center w-full">
                                                                <div className="text-sm">Did you practice yoga today?</div>
                                                                <Switch
                                                                    checked={el.completed}
                                                                    onChange={(event) =>
                                                                        updateActivitylineItem(
                                                                            e.timing,
                                                                            elI,
                                                                            event.target.checked
                                                                        )
                                                                    }
                                                                    size="large"
                                                                    sx={{
                                                                        "& .MuiSwitch-switchBase.Mui-checked": { color: "#7FD67F" },
                                                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                                            backgroundColor: "#7FD67F",
                                                                        },
                                                                        "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
                                                                    }}
                                                                    inputProps={{ "aria-label": "controlled" }}
                                                                />
                                                            </div>
                                                            <div className="flex items-center gap-5 overflow-x-auto recommendatedyogacards">
                                                                {el.yoga.map((element) => (
                                                                    <div
                                                                        key={element?.id || element?.Id}
                                                                        className="recommendatedyogacard"
                                                                        onClick={() => navigate(`/yoga?id=${element?.id || element?.Id}`)}
                                                                    >
                                                                        <img src={element?.fullimage} alt={element?.title} />
                                                                        <p>{element?.title}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Pranayama */}
                                                    {el?.pranayama && (
                                                        <div>
                                                            <div className="mt-3 flex justify-between items-center w-full">
                                                                <div className="text-sm">Did you practice pranayama today?</div>
                                                                <Switch
                                                                    checked={el.completed}
                                                                    onChange={(event) =>
                                                                        updateActivitylineItem(
                                                                            e.timing,
                                                                            elI,
                                                                            event.target.checked
                                                                        )
                                                                    }
                                                                    size="large"
                                                                    sx={{
                                                                        "& .MuiSwitch-switchBase.Mui-checked": { color: "#7FD67F" },
                                                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                                            backgroundColor: "#7FD67F",
                                                                        },
                                                                        "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
                                                                    }}
                                                                    inputProps={{ "aria-label": "controlled" }}
                                                                />
                                                            </div>
                                                            <div className="flex items-center gap-5 overflow-x-auto recommendatedyogacards">
                                                                {el.pranayama.map((element) => (
                                                                    <div
                                                                        key={element?.id || element?.Id}
                                                                        className="recommendatedyogacard flex-row"
                                                                        onClick={() =>
                                                                            navigate(`/Pranayama?id=${element?.id || element?.Id}`)
                                                                        }
                                                                    >
                                                                        <img src={element?.image} alt={element?.title} />
                                                                        <p>{element?.title}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Meditation */}
                                                    {el?.meditation && (
                                                        <div>
                                                            <div className="mt-3 flex justify-between items-center w-full">
                                                                <div className="text-sm">Did you practice meditation today?</div>
                                                                <Switch
                                                                    checked={el.completed}
                                                                    onChange={(event) =>
                                                                        updateActivitylineItem(
                                                                            e.timing,
                                                                            elI,
                                                                            event.target.checked
                                                                        )
                                                                    }
                                                                    size="large"
                                                                    sx={{
                                                                        "& .MuiSwitch-switchBase.Mui-checked": { color: "#7FD67F" },
                                                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                                            backgroundColor: "#7FD67F",
                                                                        },
                                                                        "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
                                                                    }}
                                                                    inputProps={{ "aria-label": "controlled" }}
                                                                />
                                                            </div>
                                                            <div className="flex items-center gap-5 overflow-x-auto recommendatedyogacards">
                                                                {el.meditation.map((element) => (
                                                                    <div
                                                                        key={element?.id || element?.Id}
                                                                        className="recommendatedyogacard flex-row"
                                                                        onClick={() =>
                                                                            navigate(`/Meditation?id=${element?.id || element?.Id}`)
                                                                        }
                                                                    >
                                                                        <img src={element?.image} alt={element?.title} />
                                                                        <p>{element?.title}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Recipes */}
                                                    {el?.recipes && (
                                                        <div>
                                                            <div className="mt-3 flex justify-between items-center w-full">
                                                                <div className="text-sm">Have you taken your {getMealLabel(e.timing)}?</div>
                                                                {el.completed ? (
                                                                    <IconButton
                                                                        onClick={() => {
                                                                            setCurrentLineItem({
                                                                                timing: e.timing,
                                                                                lineItemIndex: elI,
                                                                                item: el.recipes,
                                                                                type: "recipes",
                                                                            });
                                                                            handleClickOpen();
                                                                            updateActivitylineItem(e.timing, elI, el.completed);
                                                                        }}
                                                                    >
                                                                        <img src={EditIcon} style={{ width: "2rem" }} alt="edit" />
                                                                    </IconButton>
                                                                ) : (
                                                                    <Switch
                                                                        checked={el.completed}
                                                                        onChange={(event) => {
                                                                            if (event.target.checked) {
                                                                                setCurrentLineItem({
                                                                                    timing: e.timing,
                                                                                    lineItemIndex: elI,
                                                                                    item: el.recipes,
                                                                                    type: "recipes",
                                                                                });
                                                                                handleClickOpen();
                                                                            }
                                                                            updateActivitylineItem(
                                                                                e.timing,
                                                                                elI,
                                                                                event.target.checked
                                                                            );
                                                                        }}
                                                                        size="large"
                                                                        sx={{
                                                                            "& .MuiSwitch-switchBase.Mui-checked": { color: "#7FD67F" },
                                                                            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                                                backgroundColor: "#7FD67F",
                                                                            },
                                                                            "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
                                                                        }}
                                                                        inputProps={{ "aria-label": "controlled" }}
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="flex gap-4 overflow-x-auto pb-2">
                                                                {el.recipes.map((element) => (
                                                                    <div
                                                                        key={element?.id}
                                                                        onClick={() => navigate(`/Recipes?id=${element?.id}`)}
                                                                        className="flex-shrink-0 w-[100px] flex flex-col items-center bg-white rounded-lg p-3 shadow cursor-pointer hover:bg-gray-50"
                                                                    >
                                                                        <img
                                                                            src={
                                                                                element?.imageLink ||
                                                                                "https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png"
                                                                            }
                                                                            alt={element?.recipe}
                                                                            className="w-14 h-14 rounded-full border object-cover"
                                                                        />
                                                                        <p className="mt-2 text-center text-sm font-medium text-[#3B362A] truncate w-full">
                                                                            {element?.recipe}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Medicines */}
                                                    {el?.medicines && (
                                                        <div>
                                                            <div className="mt-3 flex justify-between items-center w-full">
                                                                <div className="text-sm">Have you taken your Medication?</div>
                                                                <Switch
                                                                    checked={el.completed}
                                                                    onChange={(event) => {
                                                                        if (event.target.checked) {
                                                                            setCurrentLineItem({
                                                                                timing: e.timing,
                                                                                lineItemIndex: elI,
                                                                                item: el.medicines,
                                                                                type: "medicines",
                                                                            });
                                                                            handleClickOpen();
                                                                        }
                                                                        updateActivitylineItem(
                                                                            e.timing,
                                                                            elI,
                                                                            event.target.checked
                                                                        );
                                                                    }}
                                                                    size="large"
                                                                    sx={{
                                                                        "& .MuiSwitch-switchBase.Mui-checked": { color: "#7FD67F" },
                                                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                                                            backgroundColor: "#7FD67F",
                                                                        },
                                                                        "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" },
                                                                    }}
                                                                    inputProps={{ "aria-label": "controlled" }}
                                                                />
                                                            </div>
                                                            <ul className="mt-2">
                                                                {el.medicines.map((element, idx) => (
                                                                    <li key={idx}>{element?.medicine}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            </TimelineContent>
                                        </TimelineItem>
                                    ))}
                                </Timeline>
                            </div>
                        ))}
                    </div>



                    <BootstrapDialog
                        onClose={handleClose}
                        fullWidth={true}
                        maxWidth={'sm'}
                        aria-labelledby="customized-dialog-title"
                        open={open}
                    >
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: theme.palette.grey[500],
                            })}
                        >
                            <CloseIcon />
                        </IconButton>

                        <DialogContent>
                            {
                                currentLineItem?.type === 'medicines' ?

                                    <div className="mt-5 p-5">
                                        {currentLineItem?.item?.some((med) => !med.received) && (
                                            <p className="text-center medicineItemTitle">Have you purchased your medicines?</p>
                                        )}

                                        <div className="mt-2">
                                            {currentLineItem?.item
                                                ?.filter((med) => !med.received)
                                                .map((e, i) => (
                                                    <div key={e.medicine || i} className="flex flex-col gap-5" style={{ borderBottom: "1px solid #DBDBDB" }}>
                                                        <div className="flex items-center gap-5 justify-between">
                                                            <div className="medicineItem flex items-center gap-5">
                                                                <img
                                                                    src={e?.imgurl || "https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png"}
                                                                    alt="Medicine"
                                                                />
                                                                <p>{e.medicine}</p>
                                                            </div>
                                                            <div className="flex items-center gap-5">
                                                                <IconButton
                                                                    onClick={() => {
                                                                        setCurrentLineItem((prev) => ({
                                                                            ...prev,
                                                                            item: prev.item.map((med) =>
                                                                                med.medicine === e.medicine
                                                                                    ? { ...med, received: false, taken: false }
                                                                                    : med
                                                                            )
                                                                        }));
                                                                    }}
                                                                >
                                                                    <CloseIcon fontSize="small" />
                                                                </IconButton>

                                                                <IconButton
                                                                    onClick={() => {
                                                                        setCurrentLineItem((prev) => ({
                                                                            ...prev,
                                                                            item: prev.item.map((med) =>
                                                                                med.medicine === e.medicine
                                                                                    ? { ...med, received: true }
                                                                                    : med
                                                                            )
                                                                        }));
                                                                    }}
                                                                >
                                                                    <CheckIcon fontSize="small" />
                                                                </IconButton>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>

                                        {currentLineItem?.item?.some((med) => med.received) && (
                                            <p className="text-center medicineItemTitle mt-3">Have you taken your medication?</p>
                                        )}

                                        <div className="mt-2">
                                            {currentLineItem?.item
                                                ?.filter((med) => med.received)
                                                .map((e, i) => (
                                                    <div key={e.medicine || i} className="flex flex-col gap-5" style={{ borderBottom: "1px solid #DBDBDB" }}>
                                                        <div className="flex items-center gap-5 justify-between">
                                                            <div className="medicineItem flex items-center gap-5">
                                                                <img
                                                                    src={e?.imgurl || "https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png"}
                                                                    alt="Medicine"
                                                                />
                                                                <p>{e.medicine}</p>
                                                            </div>

                                                            <div className="flex items-center gap-5">
                                                                <Switch
                                                                    checked={e?.taken || false}
                                                                    onChange={(event) => {
                                                                        setCurrentLineItem((prev) => ({
                                                                            ...prev,
                                                                            item: prev.item.map((med) =>
                                                                                med.medicine === e.medicine
                                                                                    ? { ...med, taken: event.target.checked }
                                                                                    : med
                                                                            )
                                                                        }));
                                                                    }}
                                                                    size="large"
                                                                    sx={{
                                                                        "& .MuiSwitch-switchBase.Mui-checked": { color: "#7FD67F" },
                                                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#7FD67F" },
                                                                        "& .MuiSwitch-track": { backgroundColor: "#bdbdbd" }
                                                                    }}
                                                                    inputProps={{ "aria-label": "controlled" }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>

                                    : currentLineItem?.type === 'recipes' ?

                                        <div className='mt-5 p-5'>

                                            <p className='text-center medicineItemTitle'>
                                                Which {foodtimings[currentLineItem?.timing]} have you
                                                taken today?
                                            </p>

                                            <div>
                                                <div className="grid grid-cols-3 gap-4 mt-4">
                                                    {currentLineItem?.item
                                                        ?.filter((element) => element.id !== null)
                                                        .map((element, index) => (
                                                            <div
                                                                key={element.id || index}
                                                                className={`recommendatedyogacard flex flex-col items-center flex-shrink-0 w-[150px] p-2 border rounded-lg bg-[#EFEFE7] 
                                                                ${element.taken ? "border-green-500" : "border-gray-300"}`}
                                                            >

                                                                <div style={{ justifySelf: "flex-end", alignSelf: "flex-end" }}>
                                                                    <Checkbox
                                                                        checked={element?.taken || false}
                                                                        onChange={(event) => {
                                                                            setCurrentLineItem((prev) => ({
                                                                                ...prev,
                                                                                item: prev.item.map((med, i) =>
                                                                                    i === index ? { ...med, taken: event.target.checked } : med
                                                                                ),
                                                                            }));
                                                                        }}
                                                                        color="success"
                                                                    />
                                                                </div>

                                                                <img
                                                                    src={
                                                                        element?.imageLink ||
                                                                        "https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png"
                                                                    }
                                                                    alt={element?.recipe || "Yoga Recipe"}
                                                                    className="mx-auto rounded-full object-cover w-26 h-26 aspect-square border-2 border-gray-200"
                                                                />


                                                                <p className="text-center mt-2">{element?.recipe}</p>
                                                            </div>
                                                        ))}
                                                </div>

                                                <div className="mt-5 flex flex-row gap-5">

                                                    <TextField
                                                        label={`Enter ${foodtimings[currentLineItem?.timing]} here`}
                                                        variant="outlined"
                                                        fullWidth
                                                        sx={{
                                                            backgroundColor: "#EFEFE7",
                                                            '& .MuiOutlinedInput-root': {
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: '#DA6E0B',
                                                                },
                                                            },
                                                        }}
                                                        value={newRecipe}
                                                        onChange={(event) => setNewRecipe(event.target.value)}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {
                                                                        newRecipe !== "" ?

                                                                            <Button
                                                                                style={{
                                                                                    textTransform: 'none',
                                                                                    borderRadius: '0',
                                                                                    border: '1px solid ',
                                                                                    color: '#Fdfdfd',
                                                                                    boxSizing: 'border-box',
                                                                                    backgroundColor: "#DA6E0B",
                                                                                    borderRadius: '5px',
                                                                                    fontFamily: "'Poppins', sans-serif",
                                                                                    fontWeight: 500,
                                                                                    padding: '10px'
                                                                                }}
                                                                                onClick={() => {

                                                                                    setCurrentLineItem((prev) => ({
                                                                                        ...prev,
                                                                                        item: [
                                                                                            ...prev.item,
                                                                                            {
                                                                                                id: uuidv4(),
                                                                                                recipe: newRecipe,
                                                                                                taken: true,
                                                                                                imageLink: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png",
                                                                                            },
                                                                                        ],
                                                                                    }));

                                                                                    setNewRecipe("");

                                                                                    // updateLineItem()
                                                                                }}
                                                                            >
                                                                                Add
                                                                            </Button> : <></>
                                                                    }
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />

                                                    {!newRecipe &&
                                                        <div className='flex flex-row gap-5'>
                                                            <IconButton
                                                                sx={{
                                                                    width: 60,
                                                                    height: 60,
                                                                    backgroundColor: "#f5f5f5",
                                                                    border: "1px solid #ccc",
                                                                    transition: "all 0.3s ease",
                                                                    "&:hover": {
                                                                        backgroundColor: "#eeeeee"
                                                                    },
                                                                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",

                                                                }}
                                                                onClick={() => {
                                                                    handleClose()
                                                                    handleClickOpen2()
                                                                }}>
                                                                <img src={cameraicon} className='w-8 h-8' />
                                                            </IconButton>

                                                            {/* <IconButton>
                                                                <img src={micicon} className='w-8 h-8' />
                                                            </IconButton> */}

                                                            <VoiceInput setNewRecipe={setNewRecipe} newRecipe={newRecipe} />

                                                        </div>
                                                    }


                                                </div>

                                            </div>
                                        </div>

                                        : <></>

                            }

                        </DialogContent>

                        <DialogActions>
                            <Button autoFocus style={{
                                textTransform: 'none',
                                borderRadius: '0',
                                border: '1px solid #DA6E0B ',
                                color: '#DA6E0B',
                                boxSizing: 'border-box',
                                backgroundColor: "#FDFDFD",
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px'
                            }}
                                onClick={updateLineItem}>
                                Save changes
                            </Button>

                        </DialogActions>

                    </BootstrapDialog>

                    <Dialog
                        open={open2}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleClose2}
                        aria-describedby="alert-dialog-slide-description"
                    >

                        <DialogContent>
                            {open2 && recipeAnalysis === null ?
                                <div className='camera-container' style={{ position: "relative" }}>
                                    <Webcam
                                        audio={false}
                                        ref={webcamRef}
                                        screenshotFormat='image/jpeg'
                                        videoConstraints={videoConstraints}
                                    />

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',

                                            minHeight: '100px',
                                        }}
                                    >
                                        <Box sx={{ position: 'relative' }}>
                                            <Fab
                                                aria-label="save"
                                                color="primary"
                                                sx={buttonSx}
                                                onClick={capture}
                                            >
                                                {success ? <CheckIcon /> : <SaveIcon />}
                                            </Fab>

                                            {recipeAnalysisloading && (
                                                <CircularProgress
                                                    size={68}
                                                    sx={{
                                                        color: '#8CEB8C',
                                                        position: 'absolute',
                                                        transform: 'translate(-50%, -50%)',
                                                        zIndex: 1,
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Box>




                                </div>

                                :

                                <div>
                                    <img
                                        src={recipeAnalysis?.data}
                                        alt="Recipe" style={{

                                        }}
                                        className="w-full h-60  border"
                                    />

                                    <div className='mt-5'>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            sx={{
                                                backgroundColor: "#EFEFE7",
                                                '& .MuiOutlinedInput-root': {
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#DA6E0B',
                                                    },
                                                },
                                            }}
                                            value={newRecipe}
                                            onChange={(event) => setNewRecipe(event.target.value)}

                                        />

                                        {recipeAnalysis?.dosha_aggravation
                                            &&
                                            <div>
                                                <p style={{
                                                    fontSize: "16px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                }} className='mt-2'>
                                                    Dosha Aggravation:
                                                </p>
                                                <p style={{
                                                    fontSize: "12px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 400,
                                                }} className='mt-2'>
                                                    {recipeAnalysis?.dosha_aggravation}
                                                </p>
                                            </div>
                                        }


                                        {recipeAnalysis?.calorie_estimation
                                            &&
                                            <div>
                                                <p style={{
                                                    fontSize: "16px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                }} className='mt-2'>
                                                    Calorie Estimation:
                                                </p>
                                                <p style={{
                                                    fontSize: "12px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 400,
                                                }} className='mt-2'>
                                                    {recipeAnalysis?.calorie_estimation}
                                                </p>
                                            </div>
                                        }

                                        {recipeAnalysis?.food_score
                                            &&
                                            <div>
                                                <p style={{
                                                    fontSize: "16px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                }} className='mt-2'>
                                                    Food Score:
                                                </p>
                                                <p style={{
                                                    fontSize: "12px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 400,
                                                }} className='mt-2'>
                                                    {recipeAnalysis?.food_score}
                                                </p>
                                            </div>
                                        }

                                        {recipeAnalysis?.summary_of_ingredients &&
                                            <div>
                                                <p style={{
                                                    fontSize: "16px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                }} className='mt-2'>
                                                    Summary of Ingredients:
                                                </p>

                                                <div className='mt-2'>
                                                    <TextField
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        minRows={4}
                                                        sx={{
                                                            backgroundColor: "#EFEFE7",
                                                            '& .MuiOutlinedInput-root': {
                                                                '&.Mui-focused fieldset': {
                                                                    borderColor: '#DA6E0B',
                                                                },
                                                            },
                                                        }}
                                                        value={recipeAnalysis?.summary_of_ingredients
                                                            ?.split('-')
                                                            .filter((item, index, arr) => item.trim() !== '' || index === arr.length - 1)
                                                            .map(item => `- ${item.trim()}`)
                                                            .join('\n') || ""}
                                                        onChange={(event) => {
                                                            const value = event.target.value;

                                                            // Preserve empty lines (e.g., after pressing enter)
                                                            const lines = value.split('\n').map(line => {
                                                                const trimmed = line.trim();
                                                                return trimmed.startsWith('-') ? trimmed : `- ${trimmed}`;
                                                            });

                                                            // Join without removing empty lines
                                                            const joined = lines.join('');

                                                            setRecipeAnalysis((prev) => ({
                                                                ...prev,
                                                                summary_of_ingredients: joined,
                                                            }));
                                                        }}
                                                    />

                                                </div>

                                            </div>}

                                        {recipeAnalysis?.personalized_suggestions
                                            &&
                                            <div>
                                                <p style={{
                                                    fontSize: "16px",
                                                    fontFamily: "'Poppins', sans-serif",
                                                    fontWeight: 500,
                                                }} className='mt-2'>
                                                    Personalized Suggestions:
                                                </p>
                                                <p
                                                    style={{
                                                        fontSize: "12px",
                                                        fontFamily: "'Poppins', sans-serif",
                                                        fontWeight: 400,
                                                    }} className='mt-2'>
                                                    {recipeAnalysis?.personalized_suggestions}
                                                </p>
                                            </div>
                                        }

                                    </div>
                                </div>

                            }
                        </DialogContent>

                        {recipeAnalysis &&
                            <DialogActions>
                                <Button autoFocus style={{
                                    textTransform: 'none',
                                    borderRadius: '0',
                                    border: '1px solid #DA6E0B ',
                                    color: '#DA6E0B',
                                    boxSizing: 'border-box',
                                    backgroundColor: "#FDFDFD",
                                    borderRadius: '5px',
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                    padding: '10px'
                                }}
                                    onClick={() => {

                                        setCurrentLineItem((prev) => ({
                                            ...prev,
                                            item: [
                                                ...prev.item,
                                                {
                                                    id: uuidv4(),
                                                    recipe: newRecipe,
                                                    summary_of_ingredients: recipeAnalysis?.summary_of_ingredients,
                                                    taken: true,
                                                    imageLink: recipeAnalysis?.data || "https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png",
                                                },
                                            ],
                                        }));

                                        setNewRecipe("");

                                        setRecipeAnalysis(null)

                                        setShouldUpdateLineItem(true)

                                        handleClose2()

                                    }}>

                                    Save changes
                                </Button>
                            </DialogActions>
                        }
                    </Dialog>

                </div>

        }

    </>

};

export default ActivityTimeline